import React, { useState, useEffect } from 'react';
import './index.less'
import { Form, Button, Input, TextArea, Toast } from 'antd-mobile';
import axios from 'axios';

import computer from '../../../官网切图/qiyezuling/computer.png'
import deskbook from '../../../官网切图/qiyezuling/deskbook.png'
import print from '../../../官网切图/qiyezuling/print.png'
import phone from '../../../官网切图/qiyezuling/phone.png'
import notebook from '../../../官网切图/qiyezuling/notebook.png'
import otherservice from '../../../官网切图/qiyezuling/otherservice.png'
import { message } from 'antd';

function Enterprise() {

  const [idList, setIdList] = useState([])

  const [info, setInfo] = useState({
    enterpriseName: '',
    contacts: '',
    mobile: '',
    serviceTime: '',
    categoryList: [],
    content: '',
    license: ''
  })
  const [list, setList] = useState([])
  const [showList, setShowList] = useState(false)
  const equipmentList = [
    { title: '笔记本', key: 1 },
    { title: '台式电脑', key: 2 },
    { title: '打印机', key: 3 },
    { title: '手机', key: 4 },
    { title: '投影仪', key: 5 },
    { title: '其他', key: 6 },
  ]
  const useTimeList = ['30天内', '1～6个月', '6个月以上']
  const [showSearch,setShowSearch]=useState(false)

  useEffect(() => {

  }, [idList])


  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/user/userEnterpriseLeaseApply/insertRecord',
    responseType: 'json',
    data
  })

  const onFinish = (values) => {
    submitForm({
      categoryNames: idList.join(','),
      customerRequirement: values?.customerRequirement ? values.customerRequirement : '',
      telephone: values?.telephone ? values.telephone : undefined,
      consultType: 2,
      consultSource: 1,
    }).then(res => {
      if (res?.data?.code === 1) {
        Toast.show({
          icon: 'success',
          content: res.data.msg,
        });

      } else {
        Toast.show({
          icon: 'fail',
          content: res.data.msg,
        });
      }
    });
  };


  //  改变选中类型
  const changeStyle = (title) => {
    // 定义空数组控制返回
    // let newObjList = []
    if (idList.find(item => item === title)) {
      // 过滤id不相等数组
      let newObjList = idList.filter(val => val !== title)
      setIdList(newObjList)
      return
    }
    let newIdList = [...idList, title]

    setIdList(newIdList)
  }
  const picList = [

    {
      id: 1,
      title: "笔记本",
      url: computer,
    },
    {
      id: 2,
      title: "台式电脑",
      url: deskbook,
    }, {
      id: 3,
      title: "打印机",
      url: print,
    }, {
      id: 4,
      title: "手机",
      url: phone,
    }, {
      id: 5,
      title: "投影仪",
      url: notebook,
    },
    {
      id: 6,
      title: "其他",
      url: otherservice,
    }
  ]

  const handleInput = (e, type) => {
    if (type === 'enterpriseName') {
      if(e.length>3){
        setShowSearch(true)
      }else{
        setShowSearch(false)
      }
      // setShowList(true)
      // handelGetList({ name: e, pageNumber: 1 })
    }
    setInfo(val => ({ ...val, [type]: e }))
  }

  // 查询相关企业
  const  handleConfirm = (e) => {
    handelGetList({ name: e, pageNumber: 1,type:3 }).then(res=>{
      if(res.data.code===1){
        setShowList(true)
        setList(res.data.data?res.data.data.items:[])
      }else{
        return message.warn(res.data.msg)
      }
    })
  }

  const handelGetList=(data)=>axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/enterprise/selectEnterpriseTripartitePage',
    responseType: 'json',
    data
  })

  const handleChange=()=> {
    setShowList(false)
  }

  // 选择企业
  const handleSelect = (v) => {
    setShowList(false)
    setInfo(val => ({ ...val, enterpriseName: v.name, license: v.credit_no }))
    // this.setState({showList:false})
    // this.setState({
    //   info:{
    //     ...this.state.info,
    //     enterpriseName: v.name,
    //     license: v.credit_no
    //   }
    // })
  }

  // 使用时长
  const handleUseTime = (params) => {
    setInfo(val => ({ ...val, serviceTime: params }))
  }

  // 提交信息
  const submit=(data)=>axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/enterpriseUser/saveOrUpdateConsult',
    responseType: 'json',
    data
  })

  // 提交
  const handleSubmit=()=>{
    submit({...info,categoryList:idList,consultType: 1,
      consultSource:1,
      operation: 'add',creatorName: info.mobile,
      consultName: info.enterpriseName,}).then(res=>{
      if (res?.data?.code === 1) {
        Toast.show({
          icon: 'success',
          content: res.data.msg,
        });
        setInfo({
          enterpriseName: '',
          contacts: '',
          mobile: '',
          serviceTime: '',
          categoryList: [],
          content: '',
          license: ''
        })
        setIdList([])
      } else {
        Toast.show({
          icon: 'fail',
          content: res.data.msg,
        });
      }
    })
  }

  return (
    <div className="enterprise">
      <div className="enterprise-header">
        <div className="enterprise-container">
          <div className="enterprise-title">企业租赁</div>
          <div className="invitEnterprise" >
            <div className='invitEnterprise-title'>
              <span className='star'>＊</span>企业信息
            </div>
            <div className='invitEnterprise-inputBox '>
              <Input value={info.enterpriseName} onChange={(e) => handleInput(e, 'enterpriseName')} placeholder='请输入公司名称' placeholderStyle='color:#CCCCCC' />
              {showSearch?<div className='search' onClick={()=>handleConfirm(info.enterpriseName)}>搜索</div>:''}
              {showList && <div className='enterprise'>
                <div className='enterprise-item first' onClick={handleChange}>无匹配结果时 点击【直接输入】</div>
                {list.map(v => v && <div className='enterprise-item' onClick={() => handleSelect(v)} key={v.reg_no}>{v.name}</div>)}
              </div>}
            </div>
            <div className='invitEnterprise-inputBox nextInput'>
              <Input value={info.contacts} onChange={(e) => handleInput(e, 'contacts')} placeholder='请输入联系人姓名' placeholderStyle='color:#CCCCCC' />
            </div>
            <div className='invitEnterprise-inputBox nextInput'>
              <Input value={info.mobile} onChange={(e) => handleInput(e, 'mobile')} placeholder='请输入联系人手机号' placeholderStyle='color:#CCCCCC' />
            </div>
            <div className='invitEnterprise-title nextTitle'>
              <span className='star'>＊</span>您意向租赁的产品（可多选）
            </div>
            <div className='form-content-tunk'>
              {picList.map((item) =>
                <div
                  key={item.id}
                  className={!!idList.length && idList.find(val => val === item.title) ? 'form-content-tunk-box box-hover' : 'form-content-tunk-box'}
                  onClick={() => changeStyle(item.title)}
                >
                  <div className='form-content-tunk-box-pica' >
                    <img src={item.url} />
                  </div>
                  <div
                    className='form-content-tunk-box-item'
                  >
                    {item.title}
                  </div>
                </div>
              )}
            </div>
            <div className='invitEnterprise-title nextTitle'>
              <span className='star'>＊</span>使用时长
            </div>
            <div className='invitEnterprise-equipment'>
              {useTimeList.map(v => <div onClick={() => handleUseTime(v)} key={v} className={`item ${info.serviceTime === v && 'active'}`}>{v}</div>)}
            </div>
            <div className='invitEnterprise-title nextTitle'>
              其他
            </div>
            <div className='invitEnterprise-inputBox'>
              <Input value={info.content} onChange={(e) => handleInput(e, 'content')} placeholder='请填写其他需求' placeholderStyle='color:#CCCCCC' />
            </div>
            <div className='invitEnterprise-btn' onClick={handleSubmit}>
              提交
            </div>
            {/* <Form name="basic" className='form-content' onFinish={onFinish}>
              <div className='form-content-title'>您意向租赁的产品（可多选）</div>
              <div className='form-content-tunk'>
                {picList.map((item) =>
                  <div
                    key={item.id}
                    className={!!idList.length && idList.find(val => val === item.title) ? 'form-content-tunk-box box-hover' : 'form-content-tunk-box'}
                    onClick={() => changeStyle(item.title)}
                  >
                    <div className='form-content-tunk-box-pica' >
                      <img src={item.url} />
                    </div>
                    <div
                      className='form-content-tunk-box-item'
                    >

                      {item.title}
                    </div>
                  </div>
                )}
              </div>
              <div className='form-content-title' >其他要求（选填，可不填）</div>

              <Form.Item name="customerRequirement">
                <TextArea
                  showCount
                  rows={3}
                  maxLength={200}
                  placeholder="其他要求，例如新旧程度等；推荐方案免费咨询，不收取任何费用，快速配置最合适的配置方案。"
                />
              </Form.Item>
              <div className='form-content-bottom' >
                <div className='form-content-title' >联系电话：</div>
              </div>
              <Form.Item name='telephone' rules={[{ required: true, message: '联系方式为必填' }]}>
                <Input className='form-content-bottom-phone' placeholder='请输入手机号' required
                  onChange={(val) => console.log(val)}
                />
              </Form.Item>
              <div className='form-conten-btn'>
                <div className='form-conten-box'>
                  <Button block type='submit' color="danger" size="large">
                    提交委托
                  </Button>
                </div>
              </div>
            </Form> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Enterprise;